import { useState } from 'react';
import ModalScene from './ModalScene';
import './ModalStyles.scss';
import { useSelector } from 'react-redux';

const ModalBtn = ({ data }) => {
  const [isModalActive, setisModalActive] = useState(false);
  const lang = useSelector((state) => state.sceneController.lang);

  return (
    <>
      <button className="option" onClick={() => setisModalActive(true)}>
        <p>{lang == 'ESP' ? 'Conoce más' : 'Learn more'}</p>
      </button>
      {isModalActive && (
        <ModalScene data={data} setisModalActive={setisModalActive} />
      )}
    </>
  );
};

export default ModalBtn;
